<h2 class="titre3 text-center">{{ 'USERS_MANAGEMENT.CODE_INVITATION' | translate }}</h2>
<mat-dialog-content class="h-auto">
  <div class="overflow-x-auto rounded-lg border border-gray-200">
    <table class="w-full text-sm text-left">
      <thead class="bg-gray-50 text-gray-500">
        <tr>
          <th class="px-4 py-3 font-medium border-b border-gray-200">{{ 'USERS_MANAGEMENT.INVITATIONID' | translate }}</th>
          <th class="px-4 py-3 font-medium border-b border-gray-200">{{ 'USERS_MANAGEMENT.CODEINVITATION' | translate }}</th>
          <th class="px-4 py-3 font-medium border-b border-gray-200 min-w-40">{{ 'USERS_MANAGEMENT.DATEENVOIE' | translate }}</th>
          <th class="px-4 py-3 font-medium border-b border-gray-200">{{ 'USERS_MANAGEMENT.DATECONSOMMATION' | translate }}</th>
          <th class="px-4 py-3 font-medium border-b border-gray-200">{{ 'USERS_MANAGEMENT.ESTACTIVE' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-b border-gray-100 text-white" >
          <td class="px-4 py-3">{{invitation.invitationId}}</td>
          <td class="px-4 py-3">{{invitation.codeInvitation}}</td>
          <td class="px-4 py-3">{{invitation.dateEnvoie | date: 'yyyy-MM-dd'}}</td>
          <td class="px-4 py-3">{{invitation.dateConsommation | date: 'yyyy-MM-dd'}}</td>
          @if (invitation.dateConsommation == null) {
            <td class="px-4 py-3">{{ 'USERS_MANAGEMENT.OUI' | translate }}</td>
          }
          @if (invitation.dateConsommation !== null) {
            <td class="px-4 py-3">{{ 'USERS_MANAGEMENT.NON' | translate }}</td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="flex justify-end mt-1">
  <button mat-button color="warn" (click)="onClose()"
    class="px-4 py-2 btn-primary-novo">
    {{ 'USERS_MANAGEMENT.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
